import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Testimonial from "./components/Testimonial";
import InstagramFeed from "./components/InstagramFeed";
import Hero from "./components/Hero";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import { Toaster } from "./components/ui/toaster";

const Bridal = () => {
  const images = [
    { id: 1, url: "/portfolio/bridal-1.jpg", pos: "object-center" },
    { id: 2, url: "/portfolio/bridal-2.jpg", pos: "object-center" },
    { id: 3, url: "/portfolio/bridal-3.JPEG", pos: "object-center" },
    { id: 4, url: "/portfolio/bridal-4.JPG", pos: "object-center" },
    { id: 5, url: "/portfolio/bridal-5.JPEG", pos: "object-center" },
    { id: 6, url: "/portfolio/bridal-6.JPEG", pos: "object-center" },
    { id: 7, url: "/portfolio/bridal-7.JPG", pos: "object-center" },
    { id: 8, url: "/portfolio/bridal-8.JPEG", pos: "object-top" },
    { id: 9, url: "/portfolio/bridal-9.JPEG", pos: "object-center" }
  ];
  return (
    <div className="pt-36 pb-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20 text-center mb-16">
        <h1 className="text-3xl lg:text-4xl font-light tracking-[0.25em] uppercase text-black mb-4">Tailored to Your Essence</h1>
      </div>
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20 mb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {images.map((img) => (
            <div key={img.id} className="overflow-hidden bg-neutral-50 aspect-[3/4] group relative shadow-sm">
              <img src={img.url} alt="Bridal" className={`w-full h-full object-cover ${img.pos} transition-transform duration-700 group-hover:scale-105`} />
            </div>
          ))}
        </div>
      </div>
      <div className="text-center pt-4 pb-12">
        <Link to="/contact" className="inline-block px-10 py-3.5 border border-black text-xs font-light tracking-[0.25em] uppercase text-black hover:bg-black hover:text-white transition-all duration-300">Get in touch</Link>
      </div>
    </div>
  );
};

const Editorial = () => {
  const exts = ['.jpg', '.JPG', '.JPEG', '.png', '.PNG'];
  return (
    <div className="pt-36 pb-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20 text-center mb-16">
        <h1 className="text-3xl lg:text-4xl font-light tracking-[0.25em] uppercase text-black mb-4">Editorial Artistry</h1>
      </div>
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20 mb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {[1,2,3,4,5,6,7,8,9,10,11].map((num) => (
            <div key={num} className="overflow-hidden bg-neutral-50 aspect-[3/4] group relative shadow-sm">
              <img 
                src={`/portfolio/editorial-${num}.jpg`} 
                alt="Editorial" 
                className="w-full h-full object-cover" 
                onError={(e) => {
                  let currentSrc = e.target.src;
                  let extIndex = exts.findIndex(ext => currentSrc.endsWith(ext));
                  if (extIndex !== -1 && extIndex < exts.length - 1) {
                    e.target.src = currentSrc.replace(exts[extIndex], exts[extIndex + 1]);
                  }
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="text-center pt-4 pb-20"><Link to="/contact" className="inline-block px-10 py-3.5 border border-black text-xs font-light tracking-[0.25em] uppercase text-black hover:bg-black hover:text-white transition-all duration-300">Work with me</Link></div>
      <div className="bg-[#f9f9f9] py-24 px-12 lg:px-20 text-center border-t border-b border-black/5">
        <div className="max-w-4xl mx-auto italic text-xl">"Hey 🤍 just wanted to say I heard amazing things about your work today! Thank you for showing up and doing your thing!"<br/><br/><span className="text-xs uppercase tracking-[0.3em]">NowBeauty NYC</span></div>
      </div>
    </div>
  );
};

const Social = () => {
  const exts = ['.JPEG', '.jpg', '.JPG', '.png', '.PNG'];
  return (
    <div className="pt-36 pb-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20 text-center mb-16">
        <h1 className="text-3xl lg:text-4xl font-light tracking-[0.25em] uppercase text-black mb-4">Social Elegance</h1>
      </div>
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20 mb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {[1,2,3,4,5,6,7,8,9,10].map((num) => (
            <div key={num} className="overflow-hidden bg-neutral-50 aspect-[3/4] group relative shadow-sm">
              <img src={`/portfolio/social-${num}.JPEG`} alt="Social" className="w-full h-full object-cover" 
                onError={(e) => {
                  let currentSrc = e.target.src;
                  let extIndex = exts.findIndex(ext => currentSrc.endsWith(ext));
                  if (extIndex !== -1 && extIndex < exts.length - 1) {
                    e.target.src = currentSrc.replace(exts[extIndex], exts[extIndex + 1]);
                  }
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="text-center pt-4 pb-20"><Link to="/contact" className="inline-block px-10 py-3.5 border border-black text-xs font-light tracking-[0.25em] uppercase text-black hover:bg-black hover:text-white transition-all duration-300">Book your look</Link></div>
      <div className="bg-[#f9f9f9] py-24 px-12 lg:px-20 text-center border-t border-b border-black/5">
        <div className="max-w-4xl mx-auto italic text-xl">"Laura made me feel so beautiful and confident for my event. Her attention to detail and ability to enhance my natural features is truly remarkable."<br/><br/><span className="text-xs uppercase tracking-[0.3em]">Client Review</span></div>
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<><Hero /><Testimonial /><InstagramFeed /><Footer /></>} />
          <Route path="/about" element={<><About /><Testimonial /><InstagramFeed /><Footer /></>} />
          <Route path="/bridal" element={<><Bridal /><Testimonial /><InstagramFeed /><Footer /></>} />
          <Route path="/editorial" element={<><Editorial /><InstagramFeed /><Footer /></>} />
          <Route path="/social" element={<><Social /><InstagramFeed /><Footer /></>} />
          <Route path="/contact" element={<><Contact /><Testimonial /><InstagramFeed /><Footer /></>} />
          <Route path="/thank-you" element={<><ThankYou /><Footer /></>} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}
export default App;
